<template>
<div class="invateDialog" v-if="dialogVisible">
    <el-dialog @close='cancel' title="邀请团长" :visible.sync="dialogVisible">
        <el-radio-group v-model="item.type">
            <el-radio :label="1">方式一：分享邀请团长，并由团长创建提货点</el-radio>
            <el-radio :label="2">方式二：我创建提货点，再分享邀请团长加入</el-radio>
        </el-radio-group>
        <el-form :model="item" :rules="rules" ref="ruleForm" label-width="110px" class="demo-ruleForm form" v-if="item.type==2">
            <el-form-item label="提货点名称" prop="name" class="content">
                <el-input v-model.trim="item.name" placeholder="请输入提货点名称" clearable></el-input>
            </el-form-item>
            <el-form-item label="提货点位置" class="content" prop="provicename">
                <el-cascader :options="citysList" @change="selectedCity" ref="myCascader" v-model="currentCity"></el-cascader>
            </el-form-item>
            <el-form-item label="详细地址" prop="address" class="content">
                <el-input v-model.trim="item.address" placeholder="请输入详细地址" clearable></el-input>
            </el-form-item>
            <div class="link">
                <el-form-item label="提货点联系人" prop="linkman" class="content">
                    <el-input v-model.trim="item.linkman" placeholder="请输入提货点联系人" clearable></el-input>
                </el-form-item>
                <el-form-item label="提货点电话" prop="linktel" class="content">
                    <el-input v-model.trim="item.linktel" placeholder="请输入提货点电话" maxlength="11" clearable></el-input>
                </el-form-item>
            </div>
        </el-form>
        <div class="switch">
            <el-switch v-model="item.ischeck"></el-switch>
            <div>
                <div>我主动邀请的团长无需审核</div>
                <div class="tip">开启后，团长增加提货点，依然需要我审核</div>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="cancel">取 消</el-button>
            <el-button type="primary" @click="submit">确 定</el-button>
        </span>
    </el-dialog>
</div>
</template>

<script>
import {makeInviteHeaderUrl, saveHostRoleInfo} from 'api/brandBusiness'
import {mapGetters, mapActions} from 'vuex'
import citys from 'common/js/citys.json'
export default {
    name: 'invateDialog',
    data() {
        return {
            item: {
                type: 1,
                ischeck: false,
                address: '',
                provicename: '',
                cityname: '',
                countname: '',
                proviceid: '',
                cityid: '',
                countid: '',
                inviteroleid: '',
                inviteroletype: '',
                linkman: '',
                linktel: '',
                name: '',
            },
            dialogVisible: false,
            rules: {
                name: [
                    {required: true, message: '请输入提货点名称', trigger: 'blur'}
                ],
                address: [
                    {required: true, message: '请输入详细地址', trigger: 'blur'}
                ],
                provicename: [
                    {required: true, message: '请选择提货点位置', trigger: 'blur'}
                ],
                linkman: [
                    {required: true, message: '请输入提货点联系人', trigger: 'blur'}
                ],
                linktel: [
                    {pattern: /^1[3|4|5|7|8][0-9]{9}$/, message: '请输入正确的手机号码', trigger: 'blur'},
                    {required: true, message: '请输入提货点电话', trigger: 'blur'}
                ],
            },
            citysList: citys,
            currentCity: []
        }
    },
    mounted() {},
    methods: {
        selectedCity(city) {
            this.item.proviceid = city[0]
            this.item.cityid = city[1]
            this.item.countid = city[2]
            let nameList = this.$refs.myCascader.getCheckedNodes()[0].pathLabels
            this.item.provicename = nameList[0]
            this.item.cityname = nameList[1]
            this.item.countname = nameList[2]
        },
        openDialog() {
            this.dialogVisible = true
            this.item = {
                type: 1,
                ischeck: false,
                address: '',
                cityname: '',
                countname: '',
                inviteroleid: '',
                inviteroletype: '',
                linkman: '',
                linktel: '',
                name: '',
                provicename: '',
                proviceid: '',
                cityid: '',
                countid: '',
            }
            this.item.inviteroleid = this.brandBusiness.hostid
            this.item.inviteroletype = 2
        },
        cancel() {
            this.currentCity = []
            this.dialogVisible = false
        },
        submit() {
            if (this.item.type == '1') {
                this.$confirm('确认生成邀请链接', '提示', {
                    confirmButtonText: '确认',
                    cancelButtonText: '取消'
                }).then(() => {
                    this._save()
                })
            } else {
                this.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        this.$confirm('确认生成邀请链接', '提示', {
                            confirmButtonText: '确认',
                            cancelButtonText: '取消'
                        }).then(() => {
                            this._save()
                        })
                    }
                })
            }
        },
        _save() {
            this.setLoading(true)
            let obj = this._.cloneDeep(this.item)
            obj.ischeck = this.item.ischeck ? 1 : 0
            makeInviteHeaderUrl({
                data: Object.assign({}, obj),
                success: data => {
                    this.$emit('openLinkDialog', data.data.inviteurlurl)
                    this.setLoading(false)
                    this.cancel()
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        ...mapActions([
            'setLoading',
            'setParams'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters(['page', 'brandBusiness', 'user', 'params',])
    },
    components: {
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.invateDialog {
    .form{
        margin-top: 0;
    }
    .el-radio-group {
        margin-bottom: 20px;
        .el-radio + .el-radio {
            margin-top: 20px;
        }
    }
    .el-dialog__footer {
    }
    .switch{
        display: flex;
        padding-top: 20px;
        border-top: 1px solid #DCDFE6;
        .tip{
            color: #909399;
            margin-top: 10px;
        }
        .el-switch{
            margin-right: 20px;
        }
    }
    .addr{
        display: flex;
        .el-select+.el-select{
            margin-left: 10px;
        }
    }
    .link{
        display: flex;
    }
}
</style>
